import i18n from "i18next";

export const getShortNameFromId = (event: number, idOnly = false) => {
  const prefix = idOnly ? "" : i18n.t("events.shortName", "RD");
  return `${prefix}${event}`;
};
